import { render, staticRenderFns } from "./addzyk.vue?vue&type=template&id=920cab1a&scoped=true"
import script from "./addzyk.vue?vue&type=script&lang=js"
export * from "./addzyk.vue?vue&type=script&lang=js"
import style0 from "./addzyk.vue?vue&type=style&index=0&id=920cab1a&prod&lang=less&scoped=true"
import style1 from "./addzyk.vue?vue&type=style&index=1&id=920cab1a&prod&lang=css"
import style2 from "./addzyk.vue?vue&type=style&index=2&id=920cab1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920cab1a",
  null
  
)

export default component.exports